export enum LookupValueTypes {
  NOTIFICATION_TYPES = '@@NOTIFICAITON_TYPES',
  REPORT_TYPES = '@@REPORT_TYPES',
  NOTIFICATION_STATUS_TYPES = '@@STATUS_TYPES',
  ALLTYPES = '@@ALLTYPES',
  BYNAME = '@@BYNAME'
}
